/* eslint no-param-reassign: 0 */
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import WgptSamlProvidersAPI from 'dashboard/api/wgpt/samlProviders';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  get($state) {
    return $state.records;
  },
  getSamlProvider: $state => id => {
    return $state.records.find(record => record.id === id);
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_WGPT_SAML_PROVIDERS_UI_FLAG, { isFetching: true });
    try {
      const response = await WgptSamlProvidersAPI.get();
      commit(types.SET_WGPT_SAML_PROVIDERS, response.data);
      return response.data;
    } catch (error) {
      // Ignore error
      return undefined;
    } finally {
      commit(types.SET_WGPT_SAML_PROVIDERS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, data) => {
    commit(types.SET_WGPT_SAML_PROVIDERS_UI_FLAG, { isCreating: true });
    try {
      const response = await WgptSamlProvidersAPI.create(data);
      commit(types.ADD_WGPT_SAML_PROVIDER, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_SAML_PROVIDERS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...data }) => {
    commit(types.SET_WGPT_SAML_PROVIDERS_UI_FLAG, { isUpdating: true });
    try {
      const response = await WgptSamlProvidersAPI.update(id, data);
      commit(types.EDIT_WGPT_SAML_PROVIDER, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_SAML_PROVIDERS_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_WGPT_SAML_PROVIDERS_UI_FLAG, { isDeleting: true });
    try {
      await WgptSamlProvidersAPI.delete(id);
      commit(types.DELETE_WGPT_SAML_PROVIDER, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_SAML_PROVIDERS_UI_FLAG, { isDeleting: false });
    }
  },
  show: async ({ commit }, id) => {
    commit(types.SET_WGPT_SAML_PROVIDERS_UI_FLAG, { isFetchingItem: true });
    try {
      const { data } = await WgptSamlProvidersAPI.show(id);
      commit(types.ADD_WGPT_SAML_PROVIDER, data);
      return data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_SAML_PROVIDERS_UI_FLAG, { isFetchingItem: false });
    }
  },
};

export const mutations = {
  [types.SET_WGPT_SAML_PROVIDERS_UI_FLAG]($state, uiFlag) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlag };
  },
  [types.ADD_WGPT_SAML_PROVIDER]: MutationHelpers.setSingleRecord,
  [types.SET_WGPT_SAML_PROVIDERS]: MutationHelpers.set,
  [types.EDIT_WGPT_SAML_PROVIDER]: MutationHelpers.update,
  [types.DELETE_WGPT_SAML_PROVIDER]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
